

















import { Component, Vue, Emit } from 'vue-property-decorator'
import {  UpdateDeliveryType} from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constant from "@/utils/constant"

@Component({
  components: { VImageUpload }
})
export default class UpdateDeliveryTypeDialog extends Vue {
  private show = false
  private constant = constant
  private orderInfo: any // 打开弹窗时传过来的订单信息
  private formData: any = {
    // 变量需要换下
    deliveryType: undefined,
    orderCode: undefined,
  }

  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  // element 表单校验
  // 变量名一致
  private rules = {
    deliveryType: [this.requiredRule],
  }
  
  @Emit('close')
  private close() {
    this.show = false;
    (this.$refs.form as ElForm).resetFields()
  }

  public async open( data: any | null = {}) {
    this.show = true
    // 打开弹窗时传过来的订单信息
    this.orderInfo = data
    this.formData.deliveryType = data.deliveryType
    this.formData.orderCode = data.orderCode
    
  }

  // 保存按钮
  public async save() {
    if(this.orderInfo.deliveryType == this.formData.deliveryType){
      this.$message.success("配送方式未发送变化")
      return
    }
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      //TODO. 根据输入的值进行参数封装和调用接口
      this.formData.orderCode = this.orderInfo.orderCode

     UpdateDeliveryType(this.formData).then(res=>{
      if(res){
        this.$message.success("修改成功")
        this.$emit("success")
        this.close()
      }
     })
      
    })
  }

}
